import {
  CONSUMPTION_COST_TEXTS,
  CONSUMPTION_TABLE_TEXTS as TEXTS,
} from '../constants/consumptionsConstants';

const textSx = { textAlign: 'left' };
const numberSx = { textAlign: 'right' };

/**
 * Columnas del listado de consumos. "Materiales" es la columna de texto principal (toma el ancho
 * restante) y, como es una lista de materiales, no ordena; tampoco "Acciones". Las claves
 * ordenables son las que acepta `sort_by` en el backend.
 * @param {boolean} showCosts Si se muestra el costo original.
 * @returns {Array<{key: string, label: string, sx: Object, sortable: boolean}>}
 */
export const buildConsumptionColumns = (showCosts) =>
  [
    { key: 'number', label: TEXTS.number, sx: { ...textSx, width: 130 }, sortable: true },
    { key: 'order', label: TEXTS.order, sx: { ...textSx, width: 140 }, sortable: true },
    {
      key: 'project',
      label: CONSUMPTION_COST_TEXTS.project,
      sx: { ...textSx, width: 190 },
      sortable: true,
    },
    { key: 'materials', label: CONSUMPTION_COST_TEXTS.materials, sx: textSx, sortable: false },
    showCosts && {
      key: 'cost',
      label: CONSUMPTION_COST_TEXTS.originalCost,
      sx: { ...numberSx, width: 170 },
      sortable: true,
    },
    { key: 'warehouse', label: TEXTS.warehouse, sx: { ...textSx, width: 170 }, sortable: true },
    { key: 'date', label: TEXTS.date, sx: { ...textSx, width: 150 }, sortable: true },
    { key: 'status', label: TEXTS.status, sx: { width: 130 }, sortable: true },
    {
      key: 'responsible',
      label: TEXTS.responsible,
      sx: { ...textSx, width: 170 },
      sortable: true,
    },
    { key: 'actions', label: TEXTS.actions, sx: { width: 100 }, sortable: false },
  ].filter(Boolean);
